import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import { getDispatch, isLoadingAction } from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import {
  GET_TOTAL_COUNT,
  GET_SKU_TEST_PACKAGES_DETAILS,
  getToken,
  GET_HVCHARGESFOR_DETAILS,
  GET_TESTTYPE_DETAILS,
  getCampaignsToken,
  GET_PACKAGE_TAGLIST_NETWORK,
  getNetworkMenuId,
} from "../../Utils/types";

export const getSkuTestPackagesAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/GetProviderSKUTestDetails/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/GetProviderSKUTestDetails`;
  return HttpUtil.makePOST(url, e, {
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const getSkuPackagesAction = (e, type) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/GetProviderPackageDetails/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/GetProviderPackageDetails`;
  return HttpUtil.makePOST(url, e, {
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getDispatch(GET_SKU_TEST_PACKAGES_DETAILS, res?.data?.results, dispatch);
    }
  });
};

export const getHVChargesForAction = () => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/GetHVChargesFor/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/GetHVChargesFor`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: window.location.pathname.includes("campaigns")
        ? null
        : getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_HVCHARGESFOR_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_HVCHARGESFOR_DETAILS, {}, dispatch);
    }
  });
};

export const getPackageTagListForAction = () => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Test/GetPackageTagging`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      MenuId: getNetworkMenuId()?.menuId,
      Authorization: getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PACKAGE_TAGLIST_NETWORK, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_PACKAGE_TAGLIST_NETWORK, {}, dispatch);
    }
  });
};

export const getTestTypeAction = () => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/GetTestType/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/GetTestType`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
      Authorization: window.location.pathname.includes("campaigns")
        ? null
        : getToken(),
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TESTTYPE_DETAILS, res?.data?.results, dispatch);
    } else {
      getDispatch(GET_TESTTYPE_DETAILS, {}, dispatch);
    }
  });
};

export const addProviderSKUTestAction = (e) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/AddUpdateProviderSKUTest/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/AddUpdateProviderSKUTest`;
  return HttpUtil.makePOST(url, e, {
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
    ApiKey: API_KEY,
  });
};
export const addProviderSKUPackageAction = (e) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/AddUpdateProviderPackage/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/AddUpdateProviderPackage`;
  return HttpUtil.makePOST(url, e, {
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
    ApiKey: API_KEY,
  });
};

export const getSKUTestDetailByIdAction =
  (id, permanentTableId) => (dispatch) => {
    const url = window.location.pathname.includes("campaigns")
      ? `${API_URL_WITHOUT_USER}/Campaigns/AddUpdateProviderSKUTestGET/${getCampaignsToken()}?ProviderSKUTestMapStgId=${id}&providerSKUTestId=${permanentTableId}`
      : `${API_URL_WITHOUT_USER}/SKUPackage/AddUpdateProviderSKUTestGET?ProviderSKUTestMapStgId=${id}&providerSKUTestId=${permanentTableId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: window.location.pathname.includes("campaigns")
          ? null
          : getToken(),
      }
    );
  };
export const getSKUPackageDetailByIdAction =
  (id, permanentTableId) => (dispatch) => {
    const url = window.location.pathname.includes("campaigns")
      ? `${API_URL_WITHOUT_USER}/Campaigns/GetProviderPackageById/${getCampaignsToken()}?ProviderPackageMapStgId=${id}&providerPackageId=${permanentTableId}`
      : `${API_URL_WITHOUT_USER}/SKUPackage/GetProviderPackageById?ProviderPackageMapStgId=${id}&providerPackageId=${permanentTableId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: window.location.pathname.includes("campaigns")
          ? null
          : getToken(),
      }
    );
  };

export const getTestPackageExcelAction = (e) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/ExportToExcelProviderSKUTestDetails/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/ExportToExcelProviderSKUTestDetails`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
  });
};
export const getSKUPackageExcelAction = (e) => (dispatch) => {
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/ExportToExcelProviderPackageDetails/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/ExportToExcelProviderPackageDetails`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
  });
};

export const uploadTestSKUFileAction = (formData) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
    ? `${API_URL_WITHOUT_USER}/Campaigns/ProviderSKUFileUpload/${getCampaignsToken()}`
    : `${API_URL_WITHOUT_USER}/SKUPackage/ProviderSKUFileUpload`;
  return HttpUtil.makePOST(url, formData, {
    ApiKey: API_KEY,
    Authorization: window.location.pathname.includes("campaigns")
      ? null
      : getToken(),
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};

export const getProvidersTestListAction =
  (packageId, providerId) => (dispatch) => {
    const url = window.location.pathname.includes("campaigns")
      ? `${API_URL_WITHOUT_USER}/Campaigns/GetProvidersTestList/${getCampaignsToken()}?PackageId=${packageId}`
      : `${API_URL_WITHOUT_USER}/SKUPackage/GetProvidersTestList?PackageId=${packageId}&providerId=${providerId}`;
    return HttpUtil.makeGET(
      url,
      {},
      {
        ApiKey: API_KEY,
        Authorization: window.location.pathname.includes("campaigns")
          ? null
          : getToken(),
      }
    );
  };
